export const dataDropDown = [
  {
    id: 'checkboxAV',
    label: 'Assurance-Vie',
    value: 'assurancevie',
    name: 'contrats-filter',
    disabled: false,
  },
  {
    id: 'checkboxRetraite',
    label: 'Retraite (PER)',
    value: 'retraite',
    name: 'contrats-filter',
    disabled: false,
  },
  {
    id: 'checkboxLivret',
    label: 'Livret',
    value: 'livret',
    name: 'contrats-filter',
    disabled: false,
  },
  {
    id: 'checkboxDefiscalisation',
    label: 'Défiscalisation',
    value: 'defiscalisation',
    name: 'contrats-filter',
    disabled: false,
  },
  {
    id: 'checkboxImmo',
    label: 'Immobilier',
    value: 'immobilier',
    name: 'contrats-filter',
    disabled: false,
  },
  {
    id: 'checkboxBourse',
    label: 'Bourse',
    value: 'bourse',
    name: 'contrats-filter',
    disabled: false,
  },
];
